<template>
  <div class="wrapper-freespin">
    <ShadowBackground></ShadowBackground>
    <div class="body-freespin">
      <div :style="styleScale" class="content-freespin">
        <div
          v-if="isFreeSpinWInOtherGamePopup && (getLinkGame || getLinkGameTournament)"
          class="close-popup"
          @click="closePopup">
          <CloseButton />
        </div>
        <PopupsBackground :style="stylePopupBody" :width="768" />
        <slot :closing="closing"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

import { mapGetters } from 'vuex';
import ShadowBackground from '@/components/otherComponents/ShadowBackground.vue';
import CloseButton from '@/components/otherComponents/CloseButton.vue';
import PopupsBackground from '@/components/otherComponents/PopupsBackground.vue';

export default Vue.extend({
  name: 'WrapperFreeSpins',
  components: {
    ShadowBackground,
    CloseButton,
    PopupsBackground
  },
  data: () => ({
    closing: false
  }),
  computed: {
    ...mapGetters([
      'getAppConfiguration',
      'isFreeSpinWInOtherGamePopup',
      'getLinkGame',
      'getLinkGameTournament',
      'getIsMobile'
    ]),
    styleScale(): { transform: string; top: string; left: string } {
      let scale = this.getAppConfiguration.scale;
      let top = this.isFreeSpinWInOtherGamePopup ? 301 : 201;
      return {
        transform: 'scale(' + scale + ')',
        top: `calc(50% - ${top}px)`,
        left: `calc(50% - ${384}px)`
      };
    },
    stylePopupBody(): { height: string } {
      return {
        height: (this.isFreeSpinWInOtherGamePopup ? (this.getIsMobile ? 590 : 560) : 430) + 'px'
      };
    }
  },
  methods: {
    closePopup(): void {
      this.closing = true;
    }
  }
});
</script>

<style scoped>
.wrapper-freespin {
  position: fixed;
  width: 100%;
  height: 100%;
}

.body-freespin {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  color: rgb(255, 255, 255);
  font-family: 'myriadpro-boldcond', sans-serif;
}

.content-freespin {
  position: absolute;
}

.close-popup {
  position: absolute;
  cursor: pointer;
  z-index: 1;
  top: 13px;
  right: 15px;
  transition: all 0.1s ease;
}

img {
  max-width: none;
}

.close-popup:hover {
  transform: scale(1.05);
}

.close-popup:active {
  transform: scale(0.95);
}
</style>
